import axios from 'axios';
import config from 'constants/apiConfig';

export type RosterTemplateAssignmentRecipient = {
  userGuid: string;
  seatName?: string | null;
  resourceName?: string | null;
};

export async function postRosterTemplateAssignmentNotice(input: {
  groupGuid: string;
  templateName: string;
  recipients: RosterTemplateAssignmentRecipient[];
}): Promise<void> {
  const recipients = input.recipients.filter((recipient) =>
    recipient.userGuid.trim()
  );
  if (!input.groupGuid || recipients.length === 0) return;
  await axios.post(
    `${config.apiGateway.filledRosterTemplates}/assignment-notice`,
    {
      groupGuid: input.groupGuid,
      templateName: input.templateName,
      recipients,
    }
  );
}
